export const breadcrumbsService = {
    SCROLL_THRESHOLD: 40,
    toggleClassOnScroll: (element) => {
        if (!element) {
            return;
        }
        const wrapper = element.find(".js-breadcrumbs-wrapper");
        const height = wrapper.height();
        const parent = wrapper.parent();
        const parentHeight = parent.height();
        let ticking = false;
        const handleScroll = () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    if (window.scrollY > (height || 0)) {
                        parent.css("height", `${parentHeight}px`);
                        wrapper.addClass("breadcrumbs-wrapper--scrolled");
                    }
                    else {
                        parent.css("height", "auto");
                        wrapper.removeClass("breadcrumbs-wrapper--scrolled");
                    }
                    ticking = false;
                });
                ticking = true;
            }
        };
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    },
};
